import React from 'react';
import Ninfo from './components/Ninfo';
import SibCalculator from './components/SibCalculator';
import ReverseSibCalculator from './components/ReverseSibCalculator';
import './components/styles.css';  // Ensure the styles are applied

function App() {
    return (
        <div>
            <Ninfo />
            <SibCalculator />
            <ReverseSibCalculator />
        </div>
    );
}

export default App;
